import axios from "axios";

export const axiosClient = axios.create({
  baseURL: "https://florapoint.su/api.admin/",
  headers: {
    "Content-Type": "application/json",
  },
});
